import type { Action } from 'src/state/_types'

export const dismissNotificationPrompt: Action = ({ state }) => {
    state.notifications.promptDismissed = true
    localStorage.setItem('notification-prompt-dismissed', 'true')
}
